<div class="flex-h-c" [style.width]="width" cdkOverlayOrigin #dateRangeSettingTrigger="cdkOverlayOrigin">
    <span *ngIf="!hideLeftLabel" class="f-g nowrap pr6 primary-content-color"><i class="far fa-calendar pr6"></i>Date Range</span>
    <div class="flex-h-c a-drs-input-bd f-g f-s" [ngClass]="{'a-drs-input-bd_active':isOpenDateRangeSetting}">
        <span class="f-g f-s">
            <input type="text" #startInput [(ngModel)]="startDateStr"
                [ngClass]="{'a-invalid':startInvalidInput||dateRangeInvalid}">
        </span>
        <span class="pl6 pr6">-</span>
        <span class="f-g f-s ml6">
            <input type="text" #endInput [(ngModel)]="endDateStr"
                [ngClass]="{'a-invalid':endInvalidInput||dateRangeInvalid}">
        </span>
    </div>
    <i class="fa fa-cog primary-color poi f16"
        (click)="isOpenDateRangeSetting = !isOpenDateRangeSetting"></i>
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayPositions]="position==='right'?rightPosition:leftPosition"
    (backdropClick)="overlayOutsideClick()" (attach)="overlayAttach()" [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOrigin]="dateRangeSettingTrigger" [cdkConnectedOverlayOpen]="isOpenDateRangeSetting">
    <app-a-date-range-setting [dateScopeStart]="startDate" [toolbarTemplate]="toolbarTemplate" [initialStartType]="startType" [initialEndType]="endType" [position]="position" [format]="format" [dateScopeEnd]="endDate"
        [initialStartDate]="startDate" (onCancel)="cancle()" (onApply)="onDateRangeApply($event)"
        [initialEndDate]="endDate"></app-a-date-range-setting>
</ng-template>